import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  overflow: hidden;
  height: 100%;
  min-height: 0;

  .buttons {
    display: flex;
    flex-direction: row;
    gap: 15px;

    button {
      width: 100%;
    }
  }

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #14223b;
    border-radius: 6px;
    border: 1px solid #ced4da;
    padding: 10px 12px;
    font-weight: 600;
    gap: 10px;
  }

  .no-hover-button:hover {
    background: inherit;
    color: inherit;
    border-color: inherit;
    box-shadow: none;
    border: 1px solid #ced4da;
  }
`;

export const ListStages = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding-top: 10px;

  .helperText {
    font-size: 12px;
    color: #9ca3af;
    margin-bottom: 4px;
    cursor: default;
  }

  .divisor {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 12px;
    overflow: auto;
  }

  .listStages {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    max-height: 100%;
    padding-right: 10px;

    &::-webkit-scrollbar {
      width: 12px;
      background-color: transparent;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 12px;
    }
  }

  .stageRow {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    background: #fff;
  }

  .colorDotButton {
    position: relative;
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin-top: 10px;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .colorDotButton:hover {
    background: transparent;
    box-shadow: none;
    border: none;
  }

  .colorDot {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border-radius: 50%;
  }

  .stageInputWrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .inlineInput {
    width: 100%;
    font-size: 12px !important;
  }

  .inlineInput.p-inputtext {
    font-size: 12px !important;
    height: 38px;
    background: #f3f4f6;
    border: 1px solid #dfe3e8;
    color: #374151;
  }

  .inlineInput.p-inputtext:enabled:hover {
    border-color: #dfe3e8;
  }

  .inlineInput.p-inputtext:enabled:focus {
    box-shadow: none;
    border-color: #dfe3e8;
  }

  .inlineErrors {
    font-size: 12px;
    color: #aa3939;
  }

  .hiddenColorInput {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;
  }

  .deleteButton {
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 0;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    cursor: pointer;
    margin-top: 3px;
  }

  .deleteButton:hover {
    background: transparent;
    color: #374151;
    box-shadow: none;
    border: none;
  }

  .addStageButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: #f3f4f6;
    border: 1px solid #dfe3e8;
    color: #374151;
    border-radius: 6px;
    gap: 5px;
    font-weight: 500;
    padding: 8px 12px;
    cursor: pointer;
  }

  .addStageButton:hover {
    background: #eceff3;
    border-color: #d1d5db;
    color: #374151;
    box-shadow: none;
  }
`;
